import { createFeatureSelector, createSelector } from "@ngrx/store";
import { NavigationState } from "./navigation.state";
import { StoreConstants } from "src/app/constants/StoreConstants";

export const selectNavigationState = createFeatureSelector<NavigationState>(StoreConstants.STATE_NS);

export const selectTrigger = createSelector(
    selectNavigationState,
    (state: NavigationState): boolean => state.trigger
);

export const selectRouteOnDirty = createSelector(
    selectNavigationState,
    (state: NavigationState): string => state.routeOnDirty
);

export const selectHasDirtyForm = createSelector(
    selectNavigationState,
    (state: NavigationState): boolean => state.hasDirtyForm
);

export const selectAllowUnload = createSelector(
    selectNavigationState,
    (state: NavigationState): boolean => state.allowUnload
);

export const selectPreviousRoute = createSelector(
    selectNavigationState,
    (state: NavigationState): string => state.previousRoute
);